import {
  DebouncedTextInput,
  Group,
  GroupItem,
  GroupTitle,
  Toolbar,
  useFieldLabel,
} from "ra-friendsofbabba";
import { DocsInput, YearSelectInput } from "../component/input";
import { SimpleForm, minValue, required, useTranslate } from "react-admin";

import AuthorsInput from "./inputs/AuthorsInput";
import React from "react";
import ScientificProductionStatusInput from "./inputs/ScientificProductionStatusInput";
import ScientificProductionTypeInput from "./inputs/ScientificProductionTypeInput";
import ScientificProductionTypeOtherInput from "./inputs/ScientificProductionTypeOtherInput";
import { get } from "lodash";

const docsOptionallyRequired = () => (value, values) => {
  // Se la produzione scientifica è nello stato:
  // - "In corso di redazione" (Id: 1), l'allegato non è obbligatorio.
  const scientificProductionStatusId = get(
    values,
    "scientific_production_status_id"
  );
  if (
    scientificProductionStatusId === 1 &&
    (!value || value === null || value.length === 0)
  ) {
    return false;
  }
  return required()(value, values);
};
const Form = ({ classes, ...props }) => {
  const translate = useTranslate();
  const fieldLabel = useFieldLabel(props);
  return (
    <SimpleForm
      {...props}
      toolbar={
        <Toolbar
          backTab={3}
          backReference="technical-reports"
          backReferenceTarget="technical_report_id"
        />
      }
    >
      <Group wrapper>
        <GroupTitle
          title={translate(
            "resources.technical-report-scientific-productions.name"
          )}
        />
      </Group>
      <DebouncedTextInput
        source="name"
        maxLength={1000}
        validate={[required()]}
        multiline
        fullWidth
      />
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <ScientificProductionStatusInput
            source="scientific_production_status_id"
            validate={required()}
          />
        </GroupItem>
        <GroupItem lg={4} md={5} sm={6}>
          <ScientificProductionTypeInput
            source="scientific_production_type_id"
            validate={required()}
          />
        </GroupItem>
        <GroupItem lg={4} md={5} sm={6}>
          <ScientificProductionTypeOtherInput source="scientific_production_type_other" />
        </GroupItem>
      </Group>
      <Group wrapper>
        <GroupTitle
          title={translate(
            "resources.technical-report-scientific-productions.fields.authors"
          )}
          divider={false}
        />
      </Group>
      <AuthorsInput
        source="technical_report_scientific_production_authors"
        validate={required()}
        fullWidth
      />
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <YearSelectInput
            source="year"
            validate={[required(), minValue(2020)]}
          />
        </GroupItem>
      </Group>
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <DebouncedTextInput source="magazine" maxLength={250} />
        </GroupItem>
      </Group>
      <DebouncedTextInput
        source="impact_factor"
        maxLength={4000}
        fullWidth
        multiline
      />
      <DocsInput
        source="docs"
        fullWidth
        validate={[docsOptionallyRequired()]}
      />
      <DebouncedTextInput
        source="compatibility"
        validate={required()}
        maxLength={4000}
        fullWidth
        multiline
      />
      <DebouncedTextInput
        source="notes"
        helperText={fieldLabel("notes.help")}
        maxLength={4000}
        multiline
        fullWidth
      />
    </SimpleForm>
  );
};
export default Form;
